<div
    dropdown
    class="d-flex align-items-center ms-1 ms-lg-3"
    data-toggle="dropdown"
    aria-expanded="true"
    container="body">
    <div dropdownToggle [class]="customStyle" id="notificationIcon">
        <i [class]="iconStyle" *ngIf="unreadNotificationCount"></i>
        <span
            class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-warning"
            *ngIf="unreadNotificationCount">
            {{ unreadNotificationCount }}
        </span>
        <i class="flaticon-alarm fs-2" *ngIf="!unreadNotificationCount"></i>
    </div>
    <ng-container *ngIf="isRight">
        <div
            *dropdownMenu
            class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up menu-column legacy-notifications-dropdown">
            <ng-container *ngTemplateOutlet="dropdownMenuContent"></ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="!isRight">
        <div
            *dropdownMenu
            class="dropdown-menu p-0 m-0 dropdown-menu-left dropdown-menu-anim-up menu-column legacy-notifications-dropdown">
            <ng-container *ngTemplateOutlet="dropdownMenuContent"></ng-container>
        </div>
    </ng-container>
</div>

<ng-template #dropdownMenuContent>
    <div class="legacy-notification-header">
        <span class="legacy-notification-header-title">
            {{ unreadNotificationCount }} {{ 'NewNotifications' | localize }}
        </span>
    </div>
    <div class="legacy-notification-body">
        <div class="legacy-notification-toolbar">
            <a
                href="javascript:;"
                class="legacy-notification-link"
                *ngIf="unreadNotificationCount"
                (click)="setAllNotificationsAsRead(); $event.preventDefault(); $event.stopPropagation()">
                {{ 'SetAllAsRead' | localize }}
            </a>
            <a
                href="javascript:;"
                class="legacy-notification-link ms-auto"
                (click)="openNotificationSettingsModal()">
                {{ 'Settings' | localize }}
            </a>
        </div>
        <hr class="legacy-notification-separator" />
        <ng-scrollbar class="legacy-notification-scroll">
            <div
                *ngFor="let notification of notifications"
                class="legacy-notification-item"
                (click)="gotoUrl(notification.url)"
                [ngClass]="{
                    'legacy-notification-item-clickable': notification.url,
                    'legacy-notification-item-unread': notification.isUnread,
                }">
                <span class="legacy-notification-badge"></span>
                <span class="legacy-notification-text">{{ notification.text }}</span>
                <span class="legacy-notification-time">
                    {{ notification.creationTime | luxonFromNow }}
                    <a
                        href="javascript:;"
                        *ngIf="notification.isUnread"
                        class="legacy-notification-setread"
                        (click)="
                            setNotificationAsRead(notification);
                            $event.preventDefault();
                            $event.stopPropagation()
                        ">
                        {{ 'SetAsRead' | localize }}
                    </a>
                </span>
            </div>
            <span *ngIf="!notifications.length" class="legacy-notification-empty">
                {{ 'ThereAreNoNotifications' | localize }}
            </span>
        </ng-scrollbar>
        <div class="legacy-notification-footer" *ngIf="notifications.length">
            <a routerLink="notifications" class="legacy-notification-seeall">
                {{ 'SeeAllNotifications' | localize }}
            </a>
        </div>
    </div>
</ng-template>
